import { gql } from '@apollo/client';

export const CREATE_PAYMENT_SESSION = gql`
  mutation create_payment_session($data: CreatePaymentSessionInputType!) {
    create_payment_session(data: $data) {
      hasError
      message
      data
    }
  }
`;
